import { render, staticRenderFns } from "./Intel.vue?vue&type=template&id=293c46d6&scoped=true&"
import script from "./Intel.vue?vue&type=script&lang=js&"
export * from "./Intel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293c46d6",
  null
  
)

export default component.exports